import React from 'react'
import { Link } from 'react-router-dom'
import TimeAgo from 'react-timeago'


class Update4 extends React.Component{



render() {

  return(
  <div>
  <h1 className="introduction-header" >Authentication Update</h1>
  <p className="introduction-p-italic">
  By Nathan Sellers <TimeAgo date="Dec 4, 2018" />
  </p>
    <p className="introduction-p"> New Keys to the <span className="orange">Newforma API Kingdom</span>!</p>
    <p className="introduction-p">
    The Newforma API team is ready to present you with a new way to authenticate and access our APIs, this method applies to both Hybrid and Enterprise. The gist
    of this new feature is after installing Newforma Link, which contains the APIs on your Newforma Project Center Servers, you can now access it directly from within
    your environment.
    <br />
    <br />
    For more information on setting this up please see our <Link to="/getting-started">Getting Started page.</Link>
    </p>


    <p className="introduction-p"> We of course will not be stopping here, everyday our Developers are working hard to create more powerful API resources to give
      you access to the information you need. Please visit the Updates page frequently to keep up with the most recent releases.

    </p>


    </div> )
}
}
export default Update4;



/** WEBPACK FOOTER **
 ** ./src/pages/Updates/update4.js
 **/